import { FormattedMessage } from "react-intl";
import CreatePasscodeIcon from "../../../components/Common/SvgIcons/EventsIcons/CreatePasscodeIcon";
import { colors } from "../../stripeColors";
import { roleMenuList } from "../../roleMenuList";
import { featureList } from "../../featureList";

export const createPasscode = {
  label: <FormattedMessage id="CREATE_PASSCODE" />,
  path: (tenantName) => `/${tenantName}/events/createPasscode`,
  icon: CreatePasscodeIcon,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="MANAGE_VQVT" />,
      path: `/${tenantName}/events`,
      onClick: () => navigate(`/${tenantName}/events`),
    },
    {
      key: 2,
      label: <FormattedMessage id="CREATE_PASSCODE" />,
      path: `${createPasscode.path(tenantName)}`,
      onClick: () => navigate(`${createPasscode.path(tenantName)}`),
    },
  ],
  tiles: (navigate, tenantName) => [
    {
      key: 1,
      label: "Virtual Quiz",
      path: `${createPasscode.path(tenantName)}/virtualQuizEvents`,
      color: colors.red,
      onClick: () =>
        navigate(`${createPasscode.path(tenantName)}/virtualQuizEvents`),
      // name: [roleMenuList?.EVENTS?.VIRTUAL_QUIZ],
      // feature: [featureList?.VIRTUAL_QUIZ],
      feature: [
        {
          roleMenu: roleMenuList?.EVENTS?.VIRTUAL_QUIZ,
          MSOMMenu: featureList?.VIRTUAL_QUIZ,
        },
      ],
    },
    {
      key: 2,
      label: "Live Quiz",
      path: `${createPasscode.path(tenantName)}/liveQuizEvents`,
      color: colors.purple,
      onClick: () =>
        navigate(`${createPasscode.path(tenantName)}/liveQuizEvents`),
      // name: [roleMenuList?.EVENTS?.LIVE_QUIZ],
      // feature: [featureList?.LIVE_QUIZ],
      feature: [
        {
          roleMenu: roleMenuList?.EVENTS?.LIVE_QUIZ,
          MSOMMenu: featureList?.LIVE_QUIZ,
        },
      ],
    },
  ],
};
